<template>
  <div class="form__field" :style="{ width: field.size }">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div class="form__control">
      <input
        class="form__input"
        type="text"
        v-model="value"
        :id="identifier"
        :name="identifier"
        :placeholder="field.data ? field.data.placeholder : ''"
        @blur="validateEmail()"
      />
    </div>
    <div
      class="form__message form__message--joined form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-text",
  methods: {
    validateEmail() {
      if (!this.field.required && (!this.value || this.value.length <= 0)) {
        this.field.valid = true;
        this.field.error = null;
        return;
      }

      if (!this.value || this.value.length <= 0) {
        this.field.valid = false;
        this.field.error = "Geben Sie bitte Ihre E-Mailadresse ein";
        return;
      }
      this.validate();
    }
  }
};
</script>
